// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Archivos Tab (Document Viewer)
// Wrapper for ArchivosPanel in the document viewer tab bar
// ═══════════════════════════════════════════════════════════════

import { ArchivosPanel } from '../components/ArchivosPanel';

interface ArchivosTabProps {
  codigoDocumento: string;
  readOnly?: boolean;
}

export function ArchivosTab({ codigoDocumento, readOnly }: ArchivosTabProps) {
  return (
    <div style={{ padding: '20px 24px' }}>
      <ArchivosPanel codigoDocumento={codigoDocumento} readOnly={readOnly} />
    </div>
  );
}
